

import React from 'react';
import { motion } from 'framer-motion';
import VisualCanvas from './VisualCanvas';

const CTASection = () => {
    return (
        <section className="py-24 md:py-32 min-h-[auto] md:min-h-screen flex items-center bg-white transition-colors duration-500 overflow-hidden">
            <div className="container mx-auto px-4 md:px-6">
                <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6 }}
                    className="bg-gradient-to-br from-blue-700 via-purple-600 to-red-500 rounded-[2rem] md:rounded-[2.5rem] p-8 md:p-14 text-white relative overflow-hidden shadow-2xl shadow-blue-500/20"
                >
                    {/* 3D Visual Background */}
                    <div className="absolute inset-0 z-0 opacity-20">
                        <VisualCanvas type="sphere" color="#ffffff" height="100%" />
                    </div>

                    <div className="absolute top-0 right-0 w-[30rem] h-[30rem] bg-white/10 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2"></div>
                    <div className="absolute bottom-0 left-0 w-[20rem] h-[20rem] bg-purple-500/10 rounded-full blur-[80px] translate-y-1/2 -translate-x-1/2"></div>

                    <div className="relative z-10 max-w-4xl mx-auto text-center">
                        <motion.h2
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                            className="text-3xl md:text-5xl lg:text-6xl font-black mb-4 md:mb-8 leading-[1.1] tracking-tight"
                        >
                            Ready to Build Your <br className="hidden md:block" /> <span className="text-white drop-shadow-lg">Legacy</span>?
                        </motion.h2>
                        <motion.p
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: 0.3 }}
                            className="text-xs md:text-lg text-white/80 mb-10 md:mb-14 leading-relaxed font-medium max-w-2xl mx-auto"
                        >
                            Let's turn your vision into a scalable digital reality. Join the ecosystem of innovation.
                        </motion.p>
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: 0.4 }}
                            className="flex flex-col sm:flex-row items-center justify-center gap-6 md:gap-10"
                        >
                            <button className="w-full sm:w-auto px-10 py-4 bg-white text-primary font-black uppercase tracking-widest text-[10px] md:text-xs rounded-full transition-all flex items-center justify-center gap-2 group shadow-2xl active:scale-95">
                                Launch Your Project
                            </button>
                            <div className="flex items-center gap-4 group cursor-pointer hover:opacity-80 transition-opacity">
                                <div className="flex -space-x-3 md:-space-x-5">
                                    {[1, 2, 3].map(i => (
                                        <img key={i} src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${i + 10}`} className="w-10 h-10 md:w-12 md:h-12 rounded-full border-4 border-blue-600" alt="u" />
                                    ))}
                                </div>
                                <div className="text-left font-black text-white/80 text-xs md:text-sm tracking-wide">
                                    <p className="text-white">Join 250+ Visionaries</p>
                                    <p className="opacity-60 uppercase text-[9px] md:text-[10px]">Global Software Success</p>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default CTASection;
